import React from "react";
import {
  ResponsiveModal,
  IResponsiveModalProps,
} from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { VStack } from "@UI/Components/Stack/Stack";
import { Radio, RadioGroup } from "@UI/Components/Radio/Radio";
import { CandidateFilters, ICandidateFilter } from "../../types";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";

interface ICandidateFilterModalProps
  extends Pick<IResponsiveModalProps, "isOpen" | "onClose"> {
  filter: ICandidateFilter;
  onFilterChange: (value: ICandidateFilter) => void;
}

export const CandidateFilterModal = (props: ICandidateFilterModalProps) => {
  const { isOpen, onClose, filter, onFilterChange } = props;

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose}>
      <Heading as="h4" fontSize={{ base: "xl", lg: "3xl" }} mb="16px">
        <FormattedMessage {...messages["filterBy"]} />
      </Heading>

      <RadioGroup
        colorScheme="seaGreen"
        size="lg"
        display="flex"
        flexDirection="column"
        gap="16px"
        value={filter}
        onChange={onFilterChange}
        mb="12px"
      >
        <Radio
          value={CandidateFilters.recommended}
          alignItems="start"
          justifyContent="start"
        >
          <VStack alignItems="start" justifyContent="start">
            <Text
              as="h6"
              fontWeight={
                filter === CandidateFilters.recommended ? "700" : "initial"
              }
              lineHeight="24px"
              m="0"
            >
              <FormattedMessage
                {...messages["serviceRequest.candidates.filter.option1"]}
              />
            </Text>
            <Text fontSize={{ base: "sm", lg: "initial" }}>
              <FormattedMessage
                {...messages[
                  "serviceRequest.candidates.filter.option1.description"
                ]}
              />
            </Text>
          </VStack>
        </Radio>
        <Radio
          value={CandidateFilters.last_updated}
          border="1px solid"
          borderColor="gray.400"
        >
          <Text
            as="h6"
            fontWeight={
              filter === CandidateFilters.last_updated ? "700" : "initial"
            }
            m="0"
          >
            <FormattedMessage
              {...messages["serviceRequest.candidates.filter.option2"]}
            />
          </Text>
        </Radio>
      </RadioGroup>
    </ResponsiveModal>
  );
};
